module.exports = __webpack_public_path__ + "img/logo-white.1dc7ee58.png";